import InputV2, { InputV2Props } from './InputV2';

export type CurrencyInputV2Props = Omit<InputV2Props, 'type'>;

// Test for a number with the format: 10.11, 0.01, 1000, .1 e.g.
const regex = /^-?(\d+(\.\d{0,2})?|\.\d{0,2})?$|^$/;

function validator(val: string): boolean {
    return regex.test(val);
}

function CurrencyInputV2({ onChange, ...props }: CurrencyInputV2Props): JSX.Element {
    // Checks if the entered number can be parsed.
    function handleChange(val: string): void {
        if (val === '.' || val === '-') {
            onChange(val);
            return;
        }

        if (isNaN(+val)) {
            return;
        }
        onChange(val);
    }

    function handleBlur(e: React.FocusEvent<HTMLInputElement, Element>): void {
        const val = e.target.value.trim();

        if (val === '.' || val === '-') {
            onChange('0.00');
            return;
        }

        if (isNaN(+val) || val === '') {
            return;
        }

        onChange(e.target.value);
        if (props.onBlur) {
            props.onBlur(e);
        }
    }

    return (
        <InputV2
            type="text"
            {...props}
            textAlign={props.textAlign || 'right'}
            validator={validator}
            value={props.value}
            onChange={handleChange}
            onBlur={handleBlur}
        />
    );
}

export default CurrencyInputV2;
